export const COMBINED_KILN_OPTION_VALUE = 'kiln'
